// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"ea01a26f","304":"c9cd3a35","336":"c9cd3a35","959":"fd24e5f1"}[chunkId] + ".chunk.css";
};